module.exports = __webpack_public_path__ + "static/media/logo.99d94390.png";